import { render, staticRenderFns } from "./ChildrenInfo.vue?vue&type=template&id=629cb714"
import script from "./ChildrenInfo.vue?vue&type=script&lang=js"
export * from "./ChildrenInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports